import gql from 'graphql-tag';


const M_INSERT_ANON_USER = gql`
    mutation InsertAnonUser {
        insert_anon_users(objects: {}) {
            returning {
                id
            }
        }
    }
`;

export {
    M_INSERT_ANON_USER,
}
